import { Typography } from '@mui/material'
import { LinkDefault } from 'components/link-default'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Outlet, useLocation } from 'react-router-dom'
import { getLocalToken, clearLocalData } from 'utilities/use-local-data'
import { useNavigateProject } from 'utilities/use-navigate-project'

const PrivateRouteContainer: React.FC<React.PropsWithChildren> = ({ children }) => {
  const location = useLocation()
  const navigate = useNavigateProject()
  React.useEffect(() => {
    if (getLocalToken() !== undefined) {
      return
    }
    clearLocalData()
    navigate('/', {
      replace: true,
      state: { from: location.pathname },
    })
  }, [location.pathname, navigate])
  if (getLocalToken() === undefined) {
    return (
      <>
        <Typography variant="body1">
          <FormattedMessage
            id="PRIVATE_ROUTE_NOT_LOGGED_IN"
            values={{
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              link: (chunks: any) => (
                <LinkDefault
                  external={false}
                  to="/"
                  replace
                  state={{ from: window.location.pathname }}>
                  {chunks}
                </LinkDefault>
              ),
            }}
          />
        </Typography>
      </>
    )
  }
  return children ? <>children</> : <Outlet />
}

export default PrivateRouteContainer
